'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlFormWizard", function ($compile, $q, templateUtils, $controller, deferredUtils) {
  return {
    restrict: "E",
    controllerAs: "formWizard",
    scope: true,
    replace: true,
    transclude: true,
    template: require("./formWizard.html"),
    link: function link($scope, $el, $attrs, ctrl) {
      $attrs.$observe("wizardConfig", function (configPropName) {
        $scope.$watch(configPropName, function (config) {
          if (config == null) {
            return;
          }
          ctrl.initialize(config);
        });
      });
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        currentStep = null,
        config = null;
      ctrl.initialize = function (_config) {
        config = $scope.config = _config;
        $scope.wizardTitle = config.title;
        ctrl.loadStep(config.initialStep || 0);
      };
      ctrl.getStepNumber = function () {
        return currentStep && currentStep.idx + 1;
      };
      ctrl.isFirstStep = function () {
        return currentStep && currentStep.idx === 0;
      };
      ctrl.isLastStep = function () {
        return currentStep && currentStep.idx === config.steps.length - 1;
      };
      ctrl.toNextStep = function () {
        ctrl.loadStep(currentStep.idx + 1);
      };
      ctrl.toPreviousStep = function () {
        ctrl.loadStep(currentStep.idx - 1);
      };
      ctrl.removeCurrentStep = function () {
        if (currentStep != null) {
          currentStep.scope.$destroy();
          currentStep.element.remove();
          currentStep = null;
        }
      };
      ctrl.isCurrentStepValid = function () {
        if (currentStep == null) {
          return false;
        }
        if (currentStep.controller && currentStep.controller.isValidStep) {
          return currentStep.controller.isValidStep();
        }
        return true;
      };
      ctrl.validateAndSave = function () {
        config.save && config.save();
      };
      ctrl.loadStep = function (stepIdx) {
        ctrl.removeCurrentStep();
        var step = config.steps[stepIdx];
        var resolvesPromise = deferredUtils.resolvePromiseMap(step.resolve || {});
        var templatePromise = templateUtils.loadTemplate(step);
        $q.all([resolvesPromise, templatePromise]).then(function (resolves) {
          var stepScope = $scope.$new();
          currentStep = {
            idx: stepIdx,
            scope: stepScope
          };
          var locals = resolves[0],
            template = resolves[1];
          if (step.controller) {
            locals.$scope = stepScope;
            locals.$element = $element;
            currentStep.controller = $controller(step.controller, locals);
          }
          $compile(template)(stepScope, function (content) {
            currentStep.element = content;
            $element.find(".content").append(content);
          });
        });
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/form-wizard/formWizard.js
// module id = 2941
// module chunks = 13